module.exports = __webpack_public_path__ + "static/media/add.aef2dda3.png";